<template>
	<div id="root" class="container">

	  <tabs>
	    <tab name="Game" :selected="true">
	      <tournament-list :model="this.tournament_data"></tournament-list>
	    </tab>
	    <tab name="Leaderboard">
	      <leader-board :model="this.leaderboard_data"></leader-board>
	    </tab>
	    <!-- <tab name="Prizes">
	      <prizes :model="this.prizes_data"></prizes>
	    </tab> -->
	  </tabs>

	</div>
</template>

<script>
	import { globals } from "@/mixins/globals"
	import axios from "axios"
	import Tabs from '@/components/tabs'
	import Tab from '@/components/tab'
	import TournamentList from '@/components/tournament-list'
	import Leaderboard from '@/components/main-page-leaderboard-list'
	import Prizes from '@/components/prizes'
	export default {
		mixins: [globals],
		components: {
		  'tabs': Tabs,
		  'tab': Tab,
		  'tournament-list': TournamentList,
		  'leader-board': Leaderboard,
		  'prizes': Prizes
		},
		data() {
			return {
				leaderboard_data: [],
				prizes_data: [],
				tournament_data: []
			};
		},
		methods: {
			fetchTournamentData() {
			  var self = this;
			  var game_id = '';
			  self.$store.state.partner = self.$route.query.partner;
			  self.$store.state.user.phone = self.$route.query.contact_number;
			  if(self.$route.query.hasOwnProperty('user_name')) {
			    self.$store.state.user.name = self.$route.query.user_name;
			  }
			  if (this.$route.query.hasOwnProperty('lang') && this.$route.query.lang.length > 0) {
			  	this.$store.state.lang = this.$route.query.lang;
			  } else {
			  	this.$store.state.lang = "en"
			  }

			  if(self.isValidRequest) {
			    var url = this.$store.getters.gamesDomain+'/all_tournaments?partner='+self.partnerID+'&contact_number='+self.userPhone+'&user_name='+self.userName;
			    var headers = this.$store.getters.headers;

			    axios.get(url, {
			      headers: headers
			    }).then((resp) => {
					if(resp.status == 200 && resp.data.success) {
				      	var self = this;
				      	// this.clearTimerArray();
				        var data = resp.data;
				        var tournament_data = data.tournaments;
				        var leaderboard_data = data.leaderboard;
				        var prizes_data = data.prizes;
				        self.$store.state.mainPageTournaments = tournament_data;
				        self.$store.state.mainPageLeaderboard = leaderboard_data;
				        self.$store.state.mainPagePrizes = prizes_data;

				        this.leaderboard_data = leaderboard_data
				        this.prizes_data = prizes_data
				        this.tournament_data = tournament_data

				        this.$store.state.allTournamentsList = tournament_data;

				        self.$store.state.totalUserPoints = data.total_user_points;
				        self.$store.state.wallet.type = data.wallet_type;
				        
				        if (self.$store.state.refreshMainPageTimer == null) {
				          self.$store.state.refreshMainPageTimer = setInterval(function() {
					        	if (self.$route.path == "/main_page") {
		                      		self.fetchTournamentData();
					        	}
		                    }, 2000);
					    }
					} else {
						self.alertPopup(true, resp.data.message);
					}
			    }).catch((err) => {});

			    if(this.$ls.get("userData") != null) {
			      var user_data = JSON.parse(this.$ls.get("userData"));
			      user_data.name = self.$route.query.user_name ? self.$route.query.user_name : "";
			      user_data.phone = self.$route.query.contact_number;
			      user_data.partnerID = self.$route.query.partner;
			      if(self.$route.query.hasOwnProperty('game_id')) {
			        user_data.gameID = self.$route.query.game_id;
			      } else {
			        user_data.gameID = "";
			      }
			      if(self.$route.query.hasOwnProperty('lang') && self.$route.query.lang.length > 0) {
			        user_data.langCode = self.$route.query.lang;
			      } else {
			        user_data.langCode = "en";
			      }
			      this.$ls.set('userData', JSON.stringify(user_data));
			    }
			  } else {
			    self.alertPopup(true, "Invalid request!");
			  }
			}
		},
		mounted() {
			clearInterval(this.$store.state.refreshTournamentTimer);
			this.fetchTournamentData();
			this.getTimerForTimerArray();
		},
		created() {
			this.$store.state.tournamentStatus = []
			this.$store.state.headTitle = "Games";
			this.$store.state.showHeader = true;
			this.$store.state.showHistory = true;
			this.$store.state.showWallet = true;


			// console.log("~~~~~~~"+this.getTranslatedText("cashback"));
		}
	}
</script>


// WEBPACK FOOTER //
// src/screens/main_page.vue